import { Language } from '@nx-smartmonkey/shared/domain';
import { Requests } from '@nx-smartmonkey/shared/helpers';
import { TwoFactorMethod } from '../pages/auth/login/context/reducer';
import { requests } from '../repositories';
import { sessionRepository } from '../repositories/session';
import { SessionRepository } from '../repositories/session/SessionRepository';
import { sentryService, SentryService } from './SentryService';

export class SessionService {
  constructor(
    private sessionRepository: SessionRepository,
    private requests: Requests,
    private sentryService: SentryService
  ) {
    this.requests.setAsUserId(this.sessionRepository.getAsUser());
  }

  isLogged(): boolean {
    return this.sessionRepository.isLogged();
  }

  getToken(): string | undefined {
    return this.sessionRepository.getToken();
  }

  beAsUser(id: string) {
    this.sessionRepository.saveAsUser(id);
  }

  deleteAsUser() {
    this.sessionRepository.deleteAsUser();
  }

  getAsUser(): string | undefined {
    return this.sessionRepository.getAsUser();
  }

  async createSession({
    email,
    password,
  }: {
    email: string;
    password: string;
  }): Promise<{ twoFactorMethods: TwoFactorMethod[]; phone?: string }> {
    return this.sessionRepository.createSession({ email, password });
  }

  async validateSession({ otpCode }: { otpCode: string }): Promise<string> {
    return this.sessionRepository.validateSession({ otpCode });
  }

  async resendOTP({
    email,
    password,
    twoFactorMethod,
  }: {
    email: string;
    password: string;
    twoFactorMethod: TwoFactorMethod;
  }): Promise<string> {
    return this.sessionRepository.resendOTP({
      email,
      password,
      twoFactorMethod,
    });
  }

  deleteSession(): Promise<void> {
    this.deleteAsUser();
    this.sentryService.setUser(null);
    return this.sessionRepository.deleteSession();
  }

  async getCountry(): Promise<string> {
    const countryCode = await this.sessionRepository.getCountry();
    return countryCode;
  }

  setLanguage({ language }: { language: Language }): void {
    this.sessionRepository.setLanguage({ language });
  }

  getLanguage(): Language | undefined {
    return this.sessionRepository.getLanguage();
  }
}

export const sessionService = new SessionService(sessionRepository, requests, sentryService);
